import styled, { css, keyframes } from 'styled-components';

import { green, yellow, red } from '../../../elements/utilities/Colors';

const suiRed = '#db2828';
const suiGreen = '#21BA47';
const suiYellow = '##fbbd08';
export const createChartColors = {
  yellow: '#F0E68C',
  red: '#DC143C',
  green: '#9ACD32',
  // yellow: suiYellow,
  // red: suiRed,
  // green: suiGreen,
  white: '#ffffff',
};

const badgeCss = css`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  border-radius: 50%;
  top: -1em;
  right: -0.35em;
  width: 2em;
  height: 2em;
  line-height: 1.5em;
  font-size: 0.4em;
  font-weight: bold;
  text-align: center;
  color: #000000;
  background-color: green;
`;

export const Circle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: ${(props) => (props.size ? props.size + 'px' : 130 + 'px')};
  height: ${(props) => (props.size ? props.size + 'px' : 130 + 'px')};
  background-color: ${(props) => (props.bgcolor ? props.bgcolor : '#F0E68C')};
  border: 2px solid ${(props) => (props.bgcolor ? props.bgcolor : '#F0E68C')};
  color: ${(props) =>
    props.bgcolor === createChartColors.red ? 'white' : 'black'};
  border-radius: 50%;
  /* border: 2px solid #F0E68C; */
  /* border: 2px solid #eee; */
  &:hover {
    border: 5px solid ${(props) => props.bgcolor || '#eee'};
    font-size: 1.2em;
    transition: 0.1s;
    transition-timing-function: ease-in;
    transform: scale(1.1, 1.1);
    /* text-decoration: underline; */
    font-weight: bold;
  }
`;

export const Container = styled.div`
  grid-area: svgcircle;
  display: block;
  padding: 1em;
  text-align: center;
  & > ${Circle} {
    margin: auto;
    margin-bottom: 20px;
  }
  & span {
    position: relative;
    margin: 40px;
  }
`;

export const CircleTextLabel = styled.label`
  color: #000000;
  font-weight: bold;
`;

export const StyledLabel = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1.5em;
  font-size: 1em;
  font-weight: bold;
  text-align: center;
`;

// const fillup = keyframes`
//         to { stroke-dasharray: 158 158; }
// `;

// export const Container = styled.div`
// & svg {
//     width: 100px; height: 100px;
//     transform: rotate(-90deg);
//     background: gray;
//     border-radius: 50%;
//     border: 2px solid #F0E68C;
//   }

//   & circle {
//     fill: #FFF;
//     stroke: ${(props) => props.bgcolor ? '#' + props.bgcolor + ';' : '#F0E68C;'};
//     stroke-width: 32;
//     stroke-dasharray: 10 100; /* for 38% */
//   }
// `;

//${(props) => props.bgcolor ? '#' + props.bgcolor + ';' : '#F0E68C;'};
// export const Container = styled.div`
// grid-area: chartCont;
// display: grid;
// flex-direction: column;
// justify-items: center;
// justify-content: space-around;
// padding: 5px;
// color: #333;
// border: 1px solid gray;
// border-radius: 20px;
// background-color: #fff;
// grid-template-columns: 3fr 3fr 3fr;
// grid-template-areas: 'listSum statusUpload lanechart ';
// `;

// export const CircleWrapper = styled.div`
// width: ${(props) => props.width ? props.width + 'px;' : 130 + 'px;'}
// height:${(props) => props.height ? props.height + 'px;' : 130 + 'px;'}
// background-color: ${(props) => props.bgcolor ? '#' + props.bgcolor + ';' : '#F0E68C;'}
// border-radius: 50%;
// border: 2px solid #F0E68C;
// `;

// export const LabelText = styled.label`
// `;

// export const AnimationDelay = {
//     Delay:(seconds) => `animation-delay: -${seconds}s;`
// }
// //alert(AnimationDelay.Delay(20));
// export const Container = styled.div`
//  display: flex;

// `;

// const spin = keyframes`
//     to { transform: rotate(.5turn); }
// `;
// const bg = keyframes`
//     50% { background: #655; }
// `;

// export const CircleWrapper = styled.div`
//     position: relative;
//     width: 100px;
//     line-height: 100px;
//     border-radius: 50%;
//     background: yellowgreen;
//     background-image:
//       linear-gradient(to right, transparent 50%, #655 0);
//     color: transparent;
//     text-align: center;
//     &::before {
//         content: ’;
//         position: absolute;
//         top: 0; left: 50%;
//         width: 50%; height: 100%;
//         border-radius: 0 100% 100% 0 / 50%;
//         background-color: inherit;
//         transform-origin: left;
//         animation: ${spin} 50s linear infinite,
//                    ${bg} 100s step-end infinite;
//         -webkit-animation: ${spin} 50s linear infinite;
//         animation-play-state: paused;
//         animation-delay:${(props) => props.delay ? '-' + props.delay + 's;' : 'inherit;'}
//       }
//  `;

// animation-delay:${(props) => props.delay ? '-' + props.delay + 's;' : 'inherit;'}

// const rota= keyframes`
//     0%   { transform: rotate(0deg); }
//     100% { transform: rotate(360deg); }
// `;

// const fill= keyframes`
//     0%        { opacity: 0; }
//     50%, 100% { opacity: 1; }
//   `;

//   const mask = keyframes`
//     0% { opacity: 1; }
//     50%, 100% { opacity: 0; }
//  `;

// //export const CircleChart = ({height, width, colorCode}) => styled.div`
// export const CircleWrapper = styled.div`
//     width: 250px;
//     height: 250px;
//     position: relative;
//     background: white;
//   `;

// export const Pie = styled.div`
//     width: 50%;
//     height: 100%;
//     position: absolute;
//     background: #08C;
//     border: 10px solid rgba(0,0,0,0.4);
// `;

// export const Spinner = styled(Pie)`
//     border-radius: 125px 0 0 125px;
//     z-index: 200;
//     border-right: none;
//     animation: ${rota} 10s linear infinite;
//   `;

// export const Filler =styled(Pie)`
//     border-radius: 0 125px 125px 0;
//     z-index: 100;
//     border-left: none;
//     animation: ${fill} 10s steps(1, end) infinite;
//     left: 50%;
//     opacity: 0;
//   `;

// export const Mask = styled.div`
//     width: 50%;
//     height: 100%;
//     position: absolute;
//     z-index: 300;
//     opacity: 1;
//     background: inherit;
//     animation: ${mask} 10s steps(1, end) infinite;
//  `;
